import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faHouse, faWallet} from '@fortawesome/free-solid-svg-icons';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { faGavel } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './Footer.css';

import { useSelector } from 'react-redux';
const Footer = () => {
    const { Info }=useSelector((state) => state.users);
  return (
    <footer className="sticky-footer">
      <div className="footer-content">
        <Link to={'/account-statement'} className="footer-icon">
          <FontAwesomeIcon icon={faHistory} size="1x" title="history" />
          <span>History</span>
        </Link>
        <Link to={'/all-bid'}  className="footer-icon">
          <FontAwesomeIcon icon={faGavel} size="1x" title="Bids" />
          <span>All Bids</span>
        </Link>
       
        <Link  to={'/home'} className="footer-icon">
          <FontAwesomeIcon icon={faHouse} size="1x" title="home" />
          <span>Home</span>
        </Link>
        <Link  to={'/wallet_histroy'} className="footer-icon">
          <FontAwesomeIcon icon={faWallet} size="1x" title="Withdraw" />
          <span>wallet</span>
        </Link>
        <Link  to={'https://tara567.us?type=URL_FOR_WEBSITE'} target='_blank' className="footer-icon">
          <FontAwesomeIcon icon={faGlobe} size="1x" title="Website" />
          <span>Website</span>
        </Link>
        
        
      </div>
    </footer>
  );
};

export default Footer;
